const theme = {
  // Breakpoints
  respondTo: {
    desktopXXXL: `min-width: 2000px`,
    desktopXXL: `min-width: 1600px`,
    desktopXL: `min-width: 1440px`,
    desktopL: `min-width: 1280px`,
    desktop: `min-width: 1025px`,
    tabletAndMobile: `max-width: 1024px`,
    tablet: `min-width: 769px`,
    mobile: `max-width: 768px`,
  },
};

export default theme;
